import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { BusinessDayScreen } from '@/features/ledger/business-day-panels'

/**
 * Business day control, as an addressable screen of its own.
 *
 * The same three sections the ledger's landing page carries under its first tab: where each branch
 * stands and how a day is opened, the register behind that, and the close. It is separated so the
 * integrator can register `/ledger/business-days` and have branch managers land directly on the one
 * ledger screen most of them will ever use — at eight in the morning, has this branch got a day
 * open; at half past five, can it be closed.
 *
 * The position reads at any width. Closing refuses below `lg`; the argument is made where it is
 * implemented, in `close-business-day.tsx`.
 */
export function LedgerBusinessDaysPage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Business days"
        description="The date every posting at a branch lands on. It comes from the ledger, not from this machine — a branch that has not closed Friday is still working in Friday."
      />

      <BusinessDayScreen />
    </>
  )
}
